import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawGoogleClassroomIcon from "./RawGoogleClassroomIcon.svg.jsx";

const GoogleClassroomIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawGoogleClassroomIcon} {...props} />;
});

export default GoogleClassroomIcon;
